import { Link } from "react-router-dom";
import { getTokenPayload } from "../../utils/getTokenPayload";
import { roles } from "../../constants/commonConstants";

function ServerError() {

    const userPayload = getTokenPayload();
    let route = "/";

    if (userPayload && userPayload.roles && userPayload.roles.length > 0) {
        const userRole = userPayload.roles[0];
        route = userRole === roles.ADMIN ? "/admin" : userRole === roles.WRITER ? "/writer" : "/";  
    }
    
    return (
        <div className="w-screen h-screen flex flex-col justify-center items-center bg-gray-100">
            <div className="text-center">
                <div className="rounded-full bg-gray-200 w-40 h-40 flex justify-center items-center mx-auto mb-6">
                    <span className="text-6xl">&#128565;</span>
                </div>
                <h1 className="text-4xl font-bold text-gray-800 mb-4">500</h1>
                <p className="text-xl text-gray-600 mb-4">
                    OOPS! INTERNAL SERVER ERROR
                </p>
                <p className="text-sm text-gray-500 mb-6">
                    Sorry but something went wrong on our end. Please try again
                    later.
                </p>
                <Link
                    to={route}
                    className="text-blue-500 hover:underline text-lg font-medium"
                >
                    Back to homepage
                </Link>
            </div>
        </div>
    );
}

export default ServerError;
